import TaskAction from "../actions/TaskAction";
import { useDispatch, useSelector } from "react-redux";

const SelectionField = ({ itemId, header = false }) => {
  const dispatch = useDispatch();
  const selectionIds = useSelector((state: any) => state.taskReducer.getIn(["selectionIds"]));

  if (header) {
    const headSelected = selectionIds.size > 0;
    return (
      <div className="flex items-center h-5 w-5">
        <input
          id="hs-table-checkbox-2"
          type="checkbox"
          checked={headSelected}
          onChange={(event) => {
            dispatch(
              TaskAction.selectAllItems({
                view: "GRID",
                selected: event.target.checked,
              })
            );
          }}
          className="border-gray-200 rounded-sm text-blue-600 focus:ring-blue-500 dark:bg-neutral-800 dark:border-neutral-700 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
        />
        <label htmlFor="hs-table-checkbox-2" className="sr-only">
          Checkbox
        </label>
      </div>
    );
  }

  const rowSelected = selectionIds.includes(itemId);
  return (
    <div className="flex items-center h-5 w-5">
      <input
        id="hs-table-checkbox-all"
        type="checkbox"
        checked={rowSelected}
        onChange={(event) => {
          dispatch(
            TaskAction.selectItem({
              itemId,
              selected: event.target.checked,
            })
          );
        }}
        className="border-gray-200 rounded-sm text-blue-600 focus:ring-blue-500 dark:bg-neutral-700 dark:border-neutral-500 dark:checked:bg-blue-500 dark:checked:border-blue-500 dark:focus:ring-offset-gray-800"
      />
      <label htmlFor="hs-table-checkbox-all" className="sr-only">
        Checkbox
      </label>
    </div>
  );
};

export default SelectionField;
